import { render, staticRenderFns } from "./AnaglyphCancellation.vue?vue&type=template&id=318b7ade"
import script from "./AnaglyphCancellation.vue?vue&type=script&lang=js"
export * from "./AnaglyphCancellation.vue?vue&type=script&lang=js"
import style0 from "./AnaglyphCancellation.vue?vue&type=style&index=0&id=318b7ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports